"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var UiStateController_1 = require("../../../../../shared/UiStateController");
var routes_1 = require("../../../../shared/includes/routes");
var BonusTemplatesList_1 = require("./component/BonusTemplatesList");
var BonusTemplateEditor_1 = require("./component/BonusTemplateEditor");
var BonusTemplateOperationsConfig_1 = require("./component/BonusTemplateOperationsConfig");
var PBonusesList = /** @class */ (function (_super) {
    __extends(PBonusesList, _super);
    function PBonusesList(props) {
        var _this = _super.call(this, props) || this;
        _this.BONUS_TYPE_CODE_WAGER_ONDEP = 1;
        _this.BONUS_TYPE_CODE_WAGER_NODEP = 2;
        _this.BONUS_TYPE_CODE_WAGER_CASHB = 3;
        return _this;
    }
    PBonusesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_AB = this.props.listBrands.Subscribe("*", function (id, data) {
            _this.setState({ avail_brands: data.data });
        });
        this.SID_AL = this.props.listAvailAppLanguages.Subscribe("*", function (id, data) {
            _this.setState({ avail_languages: data.data });
        });
        this.SID_AT = this.props.listAvailAppUserPlayerTags.Subscribe("*", function (id, data) {
            _this.setState({ avail_tags: data.data });
        });
        this.SID_AC = this.props.listAppCurrency.Subscribe("*", function (id, data) {
            _this.setState({ avail_currency: data.data });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                brands_list: data.brands_list,
                all_brands: data.all_brands,
                page_size: data.tablePageSize
            });
        });
        this.setState({
            edit_mode: "LIST",
            rootRecord: null,
            localeRecord: null,
            page_num: 1,
            page_size: this.props.state.getTablePageSize(),
            brands_list: this.props.state.getBrandsList(),
            all_brands: this.props.state.getIsAllBrands(),
            avail_brands: [],
            avail_tags: [],
            avail_languages: []
        }, function () {
            _this.props.listBrands.LoadData();
            _this.props.listAvailAppLanguages.LoadData();
            _this.props.listAvailAppUserPlayerTags.LoadData();
            _this.props.listAppCurrency.LoadData();
        });
    };
    PBonusesList.prototype.componentWillUnmount = function () {
        this.props.listBrands.UnSubscribe(this.SID_AB);
        this.props.listAvailAppLanguages.UnSubscribe(this.SID_AL);
        this.props.listAvailAppUserPlayerTags.UnSubscribe(this.SID_AT);
        this.props.listAppCurrency.UnSubscribe(this.SID_AC);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    PBonusesList.prototype.onNewClick = function () {
        this.setState({ edit_mode: "NEW", rootRecord: null });
    };
    PBonusesList.prototype.onEditClick = function (item) {
        this.setState({ edit_mode: "EDIT", rootRecord: item });
    };
    PBonusesList.prototype.onConfigClick = function (item) {
        this.setState({ edit_mode: "CONFIG", rootRecord: item });
    };
    PBonusesList.prototype.onGoBackClick = function () {
        this.setState({ edit_mode: "LIST", rootRecord: null });
    };
    PBonusesList.prototype.onPageConfigChange = function (PageNum, PageSize) {
        var _this = this;
        this.setState({ page_num: PageNum }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
        });
    };
    PBonusesList.prototype.onBrandFilterChanged = function (allBrands, BrandId, Action) {
        if (Action === "checkbox") {
            this.props.state.setAllBrands(allBrands, true);
        }
        if (Action === "add") {
            this.props.state.addBrand(BrandId, true);
        }
        if (Action === "remove") {
            this.props.state.delBrand(BrandId, true);
        }
    };
    PBonusesList.prototype.getRenderObject = function () {
        if (this.state.edit_mode === "NEW") {
            return (React.createElement(BonusTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: null, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands, listBonusTypes: this.props.listBonusTypes }));
        }
        if (this.state.edit_mode === "EDIT") {
            return (React.createElement(BonusTemplateEditor_1.default, { data: this.props.data, state: this.props.state, record: this.state.rootRecord, onGoBack: this.onGoBackClick.bind(this), listBrands: this.props.listBrands, listBonusTypes: this.props.listBonusTypes }));
        }
        if (this.state.edit_mode === "CONFIG") {
            return (React.createElement(BonusTemplateOperationsConfig_1.default, { state: this.props.state, rootRecord: this.state.rootRecord, dataBonusTags: this.props.dataTags, availTags: this.state.avail_tags, dataBonusLocales: this.props.dataLocales, availLanguages: this.state.avail_languages, dataCurrencyConfig: this.props.dataCurrencyConfig, availCurrency: this.state.avail_currency, dialogSelectImage: this.props.dialogSelectImage, dialogViewText: this.props.dialogViewText, bonusWagerOnDepCfg: this.props.bonusWagerOnDepCfg, bonusWagerNoDepCfg: this.props.bonusWagerNoDepCfg, bonusWagerCashBackCfg: this.props.bonusWagerCashBackCfg, listGameSet: this.props.listGameSet, listGameSetGames: this.props.listGameSetGames, listBonusDebitTypes: this.props.listBonusDebitTypes, listBonusCancelTypes: this.props.listBonusCancelTypes, listBonusActivationTypes: this.props.listBonusActivationTypes, listBonusWithdrawTypes: this.props.listBonusWithdrawTypes, onGoBackClick: this.onGoBackClick.bind(this), ListBonusLevelSrcTypesAvail: this.props.ListBonusLevelSrcTypesAvail, listFSRanges: this.props.listFSRanges, ListGameProviderZonesAvail: this.props.ListGameProviderZonesAvail, dlgSelectKeyVal: this.props.dlgSelectKeyVal, BonusTemplateCfgZones: this.props.BonusTemplateCfgZones, DlgBonusTemplateCustomZoneEditor: this.props.DlgBonusTemplateCustomZoneEditor, ListPlayerBehaviorTypesAvail: this.props.ListPlayerBehaviorTypesAvail, DlgCloneBonusLocale: this.props.DlgCloneBonusLocale }));
        }
        if (this.state.edit_mode === "LIST") {
            return (React.createElement(BonusTemplatesList_1.default, { data: this.props.data, state: this.props.state, onNewClick: this.onNewClick.bind(this), onEditClick: this.onEditClick.bind(this), onPageConfigChanged: this.onPageConfigChange.bind(this), pageNum: this.state.page_num, pageSize: this.state.page_size, brandsList: this.state.brands_list, allBrands: this.state.all_brands, availBrands: this.state.avail_brands, onBrandFilterChanged: this.onBrandFilterChanged.bind(this), onConfigClick: this.onConfigClick.bind(this) }));
        }
        throw "No available render for active edit mode -> " + this.state.edit_mode;
    };
    PBonusesList.prototype.render = function () {
        return this.getRenderObject();
    };
    PBonusesList.getPageDescription = function (state) {
        return {
            icon: "gift",
            iconKind: "normal",
            itemId: "item-" + routes_1.routes.page_gift_bonuses + "-id",
            itemTitle: "Бонусы",
            route: routes_1.routes.page_gift_bonuses,
            docType: UiStateController_1.UIDocumentType.udtRegularPage
        };
    };
    return PBonusesList;
}(React.Component));
exports.default = PBonusesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_bonus_templates/ui/PBonusTemplatesList.tsx
// module id = 1899
// module chunks = 0